import "./Category.scss";

import { BasePage } from "@Tenants/Hc/Site/BasePage";
import { BaseCategory } from "@Base/Category/Category";
import CategoryAd from "@Tenants/Hc/Templates/CategoryAd.hbs";
import CategoryEmailAd from "@Tenants/Hc/Templates/CategoryEmailAd.hbs";
import CategoryOtEmailAd from "@Tenants/Hc/Templates/CategoryOtEmailAd.hbs";
import CategorySezzleAd from "@Tenants/Hc/Templates/CategorySezzleAd.hbs";
import { ContentService } from "@Api/ContentService";
import { Fancyapps } from "@Libraries/Fancyapps";
import { Feature } from "@Utilities/Feature";
import { Fancybox } from "typings/Fancyapps";
import { HeaderBase } from "@Base/Site/HeaderBase";
import { Tenant } from "@Utilities/Tenant";
import { TitleChanger } from "@Utilities/TitleChanger";
import queryString from 'query-string';

export class Category extends BaseCategory
{
	private QuickShopLinks: NodeListOf<HTMLElement>;
	private QuickShopModal: Fancybox;

	constructor()
	{
		super();
	}

	public Initialize(): void
	{
		super.Initialize();

		this.QuickShopLinks = document.querySelectorAll(".quickShop");

		if (document.querySelector("#filterContent") !== null)
		{
			this.ConfigureSidebar();
		}

		if (this.QuickShopLinks.length > 0)
		{
			this.ConfigureQuickShopLinks();
		}

		this.ConfigureTitleChanger();
	};

	private ConfigureTitleChanger(): void
	{
		let titleChangerText: string = "";

		if (Tenant.DomainProjectID === Tenant.ID.HalloweenCostumesAU)
		{
			titleChangerText = "👻 Don't Ghost Us!";
		}

		if (Tenant.DomainProjectID === Tenant.ID.HalloweenCostumesUS)
		{
			titleChangerText = "🦇 Don't Fly Away Yet!";
		}

		if (titleChangerText !== "")
		{
			const titleChanger = new TitleChanger(titleChangerText, 10000, 4000);
		}
	}

	/**
* @description When the filters are open, it creates a gap at the end of the results. This method copies elements from the beginning of the list and repeats them at the end until the last row is even.
* @param {number} columns The number of columns that are currently visible to the user.
*/
	public AddFiller(columns): void
	{
		const nextPageBtn = document.querySelectorAll(".pagination .page-next a");

		if (nextPageBtn.length > 0)
		{
			const json = document.getElementById("catad");

			if (json !== null)
			{
				const ads = JSON.parse(json.innerHTML);
				let adIndex = 0;
				let index = 0;
				let offset = 0;

				if (ads && ads.Ads.length)
				{
					const existingAds = document.querySelectorAll(".results > .ps-cad");
					const isDomestic = (Tenant.DomainProjectID == Tenant.ID.HalloweenCostumesUS);

					if (existingAds !== null)
					{
						existingAds.forEach((ad) =>
						{
							ad.remove();
						});
					}

					const results = document.querySelectorAll(".results > div");
					const total = results.length;

					if (total > 0)
					{
						offset = Math.floor(total / (columns + 1));
						index = offset - 1;

						if (index > 0)
						{
							// Set up necessary values for special promotions
							const holidayAds = [];
							let currentDate: Date;
							const parsed = queryString.parse(location.search);
							const simulateDateString = parsed.simulateDate as string;
							const simulateDate = new Date(simulateDateString);

							if (simulateDate instanceof Date && !isNaN(simulateDate.getTime()))
							{
								currentDate = simulateDate;
							}
							else
							{
								currentDate = new Date();
							}

							if (isDomestic && new Date("11/15/2022") <= currentDate && currentDate <= new Date("12/31/2022"))
							{
								holidayAds.push({
									ImageUrl: "/wwwroot/img/hc/us/category/ads/holidaySweaters22.jpg",
									AlternateText: "Exclusive Holiday Sweaters",
									LinkUrl: "/sweaters.html?z=1000",
									IsMadeByUs: false
								});

								holidayAds.push({
									ImageUrl: "/wwwroot/img/hc/us/category/ads/holidayCostumes22.jpg",
									AlternateText: "Exclusive Holiday Costumes",
									LinkUrl: "/holiday-costumes.html",
									IsMadeByUs: false
								});
							}

							do
							{
								let adHtml = "";
								let adObject = { ...ads.Ads[adIndex], IsMadeByUs: ads.MadeByUs };

								// Holiday MBU ads 11/15/2022 - 12/31/2022
								if (holidayAds.length > 0 && (adIndex == 0 || adIndex == 1))
								{
									// Select a random ad from the holiday pool
									const randomAdIndex = Math.floor(Math.random() * holidayAds.length);
									adObject = holidayAds.splice(randomAdIndex, 1)[0];
								}

								if (adIndex == 1 && isDomestic)
								{
									let emailAd;

									// Orange Tuesday 2025 Email Sign Up Ad
									if (new Date("09/01/2025") < currentDate && currentDate < new Date("09/03/2025"))
									{
										emailAd = CategoryOtEmailAd({
											ImageUrl: "/wwwroot/img/hc/us/category/ads/refresh/ot-bg.png",
											ImageAlternateText: "A dark background with white stars",
											TextUrl: "/wwwroot/img/hc/us/category/ads/refresh/ot-text.png",
											AlternateText: "Unlock 20% Off Your Order! Subscribe to emails or text today and receive 20% off your order! Sign Up",
											MobileCreativeId: "1042392",
											DesktopCreativeId: "1042608"
										});
									}
									else
									{
										emailAd = CategoryEmailAd({
											ImageUrl: "/wwwroot/img/hc/us/category/ads/refresh/email-top-15.png",
											ImageAlternateText: "Unlock 15% off your order",
											TextUrl: "/wwwroot/img/hc/us/category/ads/refresh/email-text-15.png",
											AlternateText: "Subscribe to emails or text & receive 15% off your order",
											BottomUrl: "/wwwroot/img/hc/us/category/ads/refresh/email-bottom.png",
											BottomAlternateText: "Monster peeking its head up",
											MobileCreativeId: "1115789",
											DesktopCreativeId: "1115784"
										});
									}

									adHtml = emailAd;
								}
								else if (adIndex == 2 && (isDomestic || Tenant.DomainProjectID == Tenant.ID.HalloweenCostumesCA))
								{
									const isSeason = Feature.IsSeason;

									adHtml = CategorySezzleAd({
										IsSeason: isSeason
									});
								}
								else if (adIndex == 3 && isDomestic)
								{
									const loyaltyAd = CategoryAd({
										ImageUrl: "/wwwroot/img/hc/us/category/ads/refresh/loyalty-bg.jpg",
										ImageAlternateText: "A blue background",
										TextUrl: "/wwwroot/img/hc/us/category/ads/refresh/loyalty-text.png",
										AlternateText: "Monster Rewards: Sign In, Shop Favorites, Get Rewarded! Start earning today!",
										LinkUrl: "/monster-rewards.html",
										IsLoyaltyAd: true
									});

									adHtml = loyaltyAd;
								}
								else if (adIndex == 0 && (isDomestic && new Date("09/13/2024") <= currentDate && currentDate <= new Date("09/19/2024")))
								{
									const hasbroAd = CategoryAd({
										ImageUrl: "/wwwroot/img/hc/us/category/ads/refresh/hasbro-bg.jpg",
										ImageAlternateText: "A dimmed image of a Hasbro Costume",
										TextUrl: "/wwwroot/img/hc/us/category/ads/refresh/hasbro-text-24.png",
										AlternateText: "Hasbro Costumes",
										LinkUrl: "/hasbro-costumes.html",
										IsPartnerAd: true
									});

									adHtml = hasbroAd;
								}
								else if (adIndex == 0 && (isDomestic && new Date("09/20/2024") <= currentDate && currentDate <= new Date("09/26/2024")))
								{
									const minecraftAd = CategoryAd({
										ImageUrl: "/wwwroot/img/hc/us/category/ads/refresh/minecraft-bg.jpg",
										ImageAlternateText: "A dimmed image of a Minecraft Costume",
										TextUrl: "/wwwroot/img/hc/us/category/ads/refresh/minecraft-text-24.png",
										AlternateText: "Minecraft Costumes",
										LinkUrl: "/minecraft-costumes.html",
										IsPartnerAd: true
									});

									adHtml = minecraftAd;
								}
								else
								{
									adHtml = CategoryAd(adObject);
								}

								if (results[index] == undefined)
								{
									break;
								}

								const adElement = document.createElement("div");
								adElement.innerHTML = adHtml;
								results[index].after(adElement.firstChild);
								index += offset + 1;
								adIndex++;

								if (adIndex == ads.Ads.length)
								{
									// start over with the first ad.
									adIndex = 0;
								}
							}
							while (index < total);
						}
					}
				}
			}
		}
	};

	public ConfigureQuickShopLinks(): void
	{
		const messageHandler = this.QuickShopClose.bind(this);
		const openHandler = this.QuickShopHandler.bind(this);

		window.addEventListener("message", messageHandler);

		this.QuickShopLinks.forEach((link: HTMLElement) =>
		{
			link.addEventListener("click", openHandler);
		});
	};

	public async QuickShopClose(e: MessageEvent): Promise<void>
	{
		if (e.data == "quickShopClose")
		{
			this.QuickShopModal.close();
		}
		else if (e.data == "quickShopUpdate")
		{
			const contentService = new ContentService();
			const header = new HeaderBase();
			contentService.ApiCall().then(() =>
			{
				if (typeof ContentService !== "undefined" && typeof ContentService.Response !== "undefined")
				{
					// Reinitialize the transit banner with the new shipping information
					header.UpdateCartIcon();
				};
			});
		}
	}

	public async QuickShopHandler(e: Event): Promise<void>
	{
		e.preventDefault();

		if (e.target instanceof Element)
		{
			const id = e.target.closest(".ps-item").parentElement.getAttribute("data-product-id");
			const href = `/product/quickshop/${id}`;
			const fancyapps = await Fancyapps.Import();
			const fancybox = fancyapps.Fancybox;
			this.QuickShopModal = new fancybox([
				{
					src: href,
					type: "iframe"
				}
			], {
				mainClass: "quickShopModal"
			});
		}
	};
}

export class CategoryPage extends BasePage
{
	public Category: Category;
	constructor()
	{
		super();
		this.Initialize();
	}

	public async Initialize(): Promise<void>
	{
		super.Initialize();
		this.Category = new Category();
	};
}

const category = new CategoryPage();